/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import AudioValue from './AudioValue';

const CallSteps = ({ steps, onFetchAudioSource, onWriteExamination }) => {
  const { t } = useTranslation('components');

  return (
    <div className="w-full">
      {steps.map(({ title, value, file }) => (
        <div className="flex flex-col items-left p-2 gap-2 w-full" key={`call_step_${title}`}>
          <div className="whitespace-normal text-left break-keep text-slate-700 font-semibold">
            {title || t('PamInquiry.call.titleNotSet')}
          </div>
          <div className="whitespace-normal text-left break-keep text-slate-900">
            {value || t('PamInquiry.call.valueNotSet')}
          </div>
          {file && (
            <AudioValue
              file={file}
              onFetchAudioSource={onFetchAudioSource}
              onWriteExamination={onWriteExamination}
            />
          )}
        </div>
      ))}
    </div>
  );
};

CallSteps.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      value: PropTypes.string,
      file: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        duration: PropTypes.number,
      }),
    }),
  ).isRequired,
  onFetchAudioSource: PropTypes.func,
  onWriteExamination: PropTypes.func,
};

export default CallSteps;
